import { useState } from 'react';

import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { doc, getDoc } from 'firebase/firestore';

import { ListItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { snapToObject } from 'utils';
import { useFirestore } from 'utils/firebase';
import Request from './Request';
import Details from './Details';

const RequestItem = ({ item, handleRemove }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [request, setRequest] = useState(null);
  const database = useFirestore();
  const theme = useTheme();

  const handleLinkClick = async () => {
    if (isLoaded) {
      setIsOpen(!isOpen);
      return;
    }

    setIsLoading(true);

    let collection;
    if (item.for === 'vacation') {
      collection = 'vacation_requests';
    } else if (item.for === 'hardware') {
      collection = 'hardware_requests';
    } else {
      collection = 'edu_budget_requests';
    }

    const queryRequests = doc(database, collection, item.requestId);

    try {
      const snapshot = await getDoc(queryRequests);
      setRequest(snapToObject(snapshot));
      setIsLoaded(true);
      setIsOpen(true);
      setIsLoading(false);
    } catch {
      enqueueSnackbar('Something went wrong', {
        variant: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    handleRemove(item.id);
  };

  return (
    <ListItem
      key={item.id}
      sx={{
        maxWidth: '100%',
        paddingBottom: 0,
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',

        '& .MuiTypography-body1': {
          fontSize: '0.9rem !important',
        },

        '& .MuiTypography-body2': {
          fontSize: '0.75rem !important',
          color: theme.palette.text.secondary,
          display: 'flex',
          alignItems: 'center',
        },
      }}
    >
      <Details
        item={item}
        isLoading={isLoading}
        handleLinkClick={handleLinkClick}
        handleClose={handleClose}
      />

      <Request data={{ ...request, for: item.for }} isOpen={isOpen} />
    </ListItem>
  );
};

RequestItem.propTypes = {
  item: PropTypes.object,
  handleRemove: PropTypes.func.isRequired,
};

RequestItem.defaultProps = {
  item: {},
};

export default RequestItem;
